import { useState } from "react";
import { http, errMsg } from "../lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";

const ROLES = [["author", "Author"], ["reader", "Reader"], ["both", "Both"]];

function WaitlistForm() {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!role) return setError("Please choose how you're here.");
    setBusy(true);
    setError("");
    try {
      await http.post("/public/waitlist", { email, role });
      setDone(true);
    } catch (err) {
      setError(err?.response?.status === 422 ? "Please enter a valid email address." : errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return <p className="font-display text-2xl leading-snug" data-testid="waitlist-success">You're on the list. We'll email you when early access opens.</p>;
  }
  return (
    <form onSubmit={submit} className="space-y-5" data-testid="waitlist-form">
      <label className="block">
        <span className="label-mono">Email</span>
        <input type="email" required className="input-paper mt-2" placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="waitlist-email-input" />
      </label>
      <fieldset>
        <legend className="label-mono">I'm here as</legend>
        <div className="flex flex-wrap gap-2.5 mt-2.5">
          {ROLES.map(([v, label]) => (
            <button type="button" key={v} aria-pressed={role === v} className={`stamp ${role === v ? "stamp-active" : ""}`} onClick={() => setRole(v)} data-testid={`waitlist-role-${v}`}>{label}</button>
          ))}
        </div>
      </fieldset>
      {error && <p className="text-sm text-[#C84B31]" data-testid="waitlist-error">{error}</p>}
      <button className="btn-primary w-full" disabled={busy} data-testid="waitlist-submit-button">{busy ? "Saving…" : "Join the waitlist"}</button>
    </form>
  );
}

export default function WaitlistDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[#FDFBF7] border-[#121210] rounded-none" data-testid="waitlist-dialog">
        <DialogTitle className="font-display text-3xl font-normal">Join the author waitlist</DialogTitle>
        <DialogDescription className="text-[#5C584E]">Get early access to AuthorOS.</DialogDescription>
        {open && <WaitlistForm />}
      </DialogContent>
    </Dialog>
  );
}
